import React from 'react';
const Invoices          = React.lazy(() => import('views/accounting/billing').then(m => ({ default: m.Billing })));
const InvoiceDetail     = React.lazy(() => import('views/accounting/billing').then(m => ({ default: m.Billing })));
const OcrReview         = React.lazy(() => import('views/accounting/ocrReview').then(m => ({ default: m.OcrReview })));
const Reconciliation    = React.lazy(() => import('views/accounting/reconciliation').then(m => ({ default: m.Reconciliation })));
const AccountingSettings = React.lazy(() => import('views/accounting/settings').then(m => ({ default: m.AccountingSettings })));
const Accountants       = React.lazy(() => import('views/accounting/accountants').then(m => ({ default: m.Accountants })));
// Facturación REAL re-vestida con el diseño contable (datos reales, sin MockProvider).
const Billing           = React.lazy(() => import('views/accounting/billing').then(m => ({ default: m.Billing })));
const AccountingDashboard = React.lazy(() => import('views/accounting/dashboard').then(m => ({ default: m.AccountingDashboard })));

// Contabilidad propiamente dicha. Datos de ejemplo hasta que existan los endpoints.
const ChartOfAccounts     = React.lazy(() => import('views/accounting/chartOfAccounts').then(m => ({ default: m.ChartOfAccounts })));
const Journal             = React.lazy(() => import('views/accounting/journal').then(m => ({ default: m.Journal })));
const Suppliers           = React.lazy(() => import('views/accounting/suppliers').then(m => ({ default: m.Suppliers })));
const AccountingPeriods   = React.lazy(() => import('views/accounting/periods').then(m => ({ default: m.AccountingPeriods })));
const AccountingReports   = React.lazy(() => import('views/accounting/reports').then(m => ({ default: m.AccountingReports })));
const Compensations        = React.lazy(() => import('views/accounting/compensations').then(m => ({ default: m.Compensations })));
const Retentions           = React.lazy(() => import('views/accounting/retentions').then(m => ({ default: m.Retentions })));
const Ats                  = React.lazy(() => import('views/accounting/ats').then(m => ({ default: m.Ats })));
const TaxForms             = React.lazy(() => import('views/accounting/taxForms').then(m => ({ default: m.TaxForms })));

const Routes = [
  {
    path: '/accounting/dashboard',
    view: AccountingDashboard,
    layout: 'app',
    permission: 'accounting',
    title: 'Contabilidad',
  },
  {
    path: '/accounting/billing',
    view: Billing,
    layout: 'app',
    permission: 'accounting',
    title: 'Facturación',
  },
  {
    path: '/accounting/invoices',
    view: Invoices,
    layout: 'app',
    permission: 'accounting',
    title: 'Facturas',
  },
  {
    path: '/accounting/invoices/:id',
    view: InvoiceDetail,
    layout: 'app',
    permission: 'accounting',
    title: 'Detalle de factura',
  },
  {
    path: '/accounting/ocr-review',
    view: OcrReview,
    layout: 'app',
    permission: 'accounting',
    title: 'Revisión OCR',
  },
  {
    path: '/accounting/reconciliation',
    view: Reconciliation,
    layout: 'app',
    permission: 'accounting',
    title: 'Acreditación bancaria',
  },
  {
    path: '/accounting/settings',
    view: AccountingSettings,
    layout: 'app',
    permission: 'accounting',
    title: 'Parámetros contables',
  },
  {
    path: '/accounting/chart-of-accounts',
    view: ChartOfAccounts,
    layout: 'app',
    permission: 'accounting',
    title: 'Plan de cuentas',
  },
  {
    path: '/accounting/journal',
    view: Journal,
    layout: 'app',
    permission: 'accounting',
    title: 'Asientos y libro diario',
  },
  {
    path: '/accounting/suppliers',
    view: Suppliers,
    layout: 'app',
    permission: 'accounting',
    title: 'Proveedores y gastos',
  },
  {
    path: '/accounting/periods',
    view: AccountingPeriods,
    layout: 'app',
    permission: 'accounting',
    title: 'Periodos contables',
  },
  {
    path: '/accounting/reports',
    view: AccountingReports,
    layout: 'app',
    permission: 'accounting',
    title: 'Reportes contables',
  },
  {
    path: '/accounting/compensations',
    view: Compensations,
    layout: 'app',
    permission: 'accounting',
    title: 'Compensaciones de conductores',
  },
  {
    path: '/accounting/retentions',
    view: Retentions,
    layout: 'app',
    permission: 'accounting',
    title: 'Retenciones',
  },
  {
    path: '/accounting/ats',
    view: Ats,
    layout: 'app',
    permission: 'accounting',
    title: 'ATS',
  },
  {
    path: '/accounting/tax-forms',
    view: TaxForms,
    layout: 'app',
    permission: 'accounting',
    title: 'Formularios Tributarios',
  },
  {
    path: '/account/accountants',
    view: Accountants,
    layout: 'app',
    permission: 'admin',
    title: 'Contadores',
  },
];

export default Routes;
